import axios from "axios";
import querystring from "querystring";

async function readCell(cell) {
  return (
    await axios.post(
      "https://script.google.com/macros/s/AKfycbxAyOsMjLrBZWqYB2w8v3SamuMCCMVStjVQupXLkZ3zvEVDo228IBrmNJn-45xJX5hX/exec",
      JSON.stringify({
        sheetUrl:
          "https://docs.google.com/spreadsheets/d/1l175WJ6lg4c0lRwHFNMDL5_MPOqsF4JeM58rGtM2_1A/edit?usp=drive_link",
        sheetName: "分級閥值",
        type: "read_cell",
        cell: cell
      })
    )
  ).data.data[0];
}

export async function getMaxLeafLength() {
  return Promise.all([
    readCell("a2"),
    readCell("b2"),
    readCell("d2"),
    readCell("e2")
  ]).then((values) => {
    let result = "葉片長度";
    const [threshold1, condition1, condition2, threshold2] = values;

    if (!!threshold1 && !!condition1) {
      result = `${threshold1} 公分 ${condition1} ${result}`;
    }
    if (!!threshold2 && !!condition2) {
      result += `${condition2} ${threshold2} 公分`;
    }

    return {
      string: result,
      values: values
    };
  });
}

export async function getMinLeafCount() {
  return Promise.all([
    readCell("a3"),
    readCell("b3"),
    readCell("d3"),
    readCell("e3")
  ]).then((values) => {
    let result = "葉片數";
    const [threshold1, condition1, condition2, threshold2] = values;

    if (!!threshold1 && !!condition1) {
      result = `${threshold1} ${condition1} ${result}`;
    }
    if (!!threshold2 && !!condition2) {
      result += ` ${condition2} ${threshold2}`;
    }

    return {
      string: result,
      values: values
    };
  });
}

export async function getLongSide() {
  return Promise.all([
    readCell("a4"),
    readCell("b4"),
    readCell("d4"),
    readCell("e4")
  ]).then((values) => {
    let result = "植株大小";
    const [threshold1, condition1, condition2, threshold2] = values;

    if (!!threshold1 && !!condition1) {
      result = `${threshold1} 公分 ${condition1} ${result}`;
    }
    if (!!threshold2 && !!condition2) {
      result += ` ${condition2} ${threshold2} 公分`;
    }

    return {
      string: result,
      values: values
    };
  });
}

export async function getAspectRatio() {
  return Promise.all([
    readCell("a5"),
    readCell("b5"),
    readCell("d5"),
    readCell("e5")
  ]).then((values) => {
    let result = "葉序角度";
    const [threshold1, condition1, condition2, threshold2] = values;

    if (!!threshold1 && !!condition1) {
      result = `${threshold1} ${condition1} ${result}`;
    }
    if (!!threshold2 && !!condition2) {
      result += ` ${condition2} ${threshold2}`;
    }

    return {
      string: result,
      values: values
    };
  });
}

export async function getLargestLeafRatio() {
  return Promise.all([
    readCell("a6"),
    readCell("b6"),
    readCell("d6"),
    readCell("e6")
  ]).then((values) => {
    let result = "最大葉片長寬比";
    const [threshold1, condition1, condition2, threshold2] = values;

    if (!!threshold1 && !!condition1) {
      result = `${threshold1} ${condition1} ${result}`;
    }
    if (!!threshold2 && !!condition2) {
      result += ` ${condition2} ${threshold2}`;
    }

    return {
      string: result,
      values: values
    };
  });
}

export async function setThreshold(
  maxLeafLength,
  minLeafCount,
  largestLeafRatio,
  longSide,
  aspectRatio
) {
  return axios.post(
    `https://ml.webduino.tw/flower/phalaenopsis-seedling/threshold`,
    querystring.stringify({
      max_leaf_length_threshold_1: maxLeafLength[0],
      max_leaf_length_condition_1: maxLeafLength[1],
      max_leaf_length_condition_2: maxLeafLength[2],
      max_leaf_length_threshold_2: maxLeafLength[3],
      min_leaf_count_threshold_1: minLeafCount[0],
      min_leaf_count_condition_1: minLeafCount[1],
      min_leaf_count_condition_2: minLeafCount[2],
      min_leaf_count_threshold_2: minLeafCount[3],
      largest_leaf_ratio_threshold_1: largestLeafRatio[0],
      largest_leaf_ratio_condition_1: largestLeafRatio[1],
      largest_leaf_ratio_condition_2: largestLeafRatio[2],
      largest_leaf_ratio_threshold_2: largestLeafRatio[3],
      long_side_threshold_1: longSide[0],
      long_side_condition_1: longSide[1],
      long_side_condition_2: longSide[2],
      long_side_threshold_2: longSide[3],
      aspect_ratio_threshold_1: aspectRatio[0],
      aspect_ratio_condition_1: aspectRatio[1],
      aspect_ratio_condition_2: aspectRatio[2],
      aspect_ratio_threshold_2: aspectRatio[3]
    })
  );
}
